import { render, staticRenderFns } from "./MedicamentConfigureList.vue?vue&type=template&id=5943b7b9&scoped=true&"
import script from "./MedicamentConfigureList.vue?vue&type=script&lang=js&"
export * from "./MedicamentConfigureList.vue?vue&type=script&lang=js&"
import style0 from "./MedicamentConfigureList.vue?vue&type=style&index=0&id=5943b7b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5943b7b9",
  null
  
)

export default component.exports